<template>
    <v-snackbar
        :value="errorMessage!==''" 
        top
        color="error"
        dense
        tile
        transition="scroll-y-transition">
        <span>{{errorMessage}}</span>
        <v-icon>mdi-alert-circle</v-icon>
    </v-snackbar>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ErrorSnackbar",
    computed: {
        ...mapGetters(["errorMessage"])
    }
}
</script>